<template>
  <CustomSelect
    v-model="selectedGender"
    :value="value"
    inputId="userGenderPicker"
    :inputLabel="inputLabel"
    @input="$emit('input', $event)"
    :customOptions="userGenderOptions"
  ></CustomSelect>
</template>

<script>
export default {
  props: {
    defaultSelectedGender: {
      type: [String, Number],
      required: false,
    },
    value: {
      type: [String, Number, null],
      default: null,
    },
    inputLabel: {
      type: [String],
      default: "جنسیت کاربر",
    },
  },
  model: {
    prop: "value",
    event: "input",
  },
  mounted() {
    if (this.defaultSelectedGender) {
      this.selectedGender = this.defaultSelectedGender;
    }
  },
  data() {
    return {
      selectedGender: null,
      userGenderOptions: [
        {
          text: "همه",
          value: null,
        },
        {
          text: "مرد",
          value: 2,
        },
        {
          text: "زن",
          value: 1,
        },
      ],
    };
  },
  components: {
    CustomSelect,
  },
};
import CustomSelect from "@/views/components/Utils/CustomSelect.vue";
</script>
